import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setOpenLoader, setTitleLoader } from '../../../../config/redux/actions';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BodyCondition from '../../../components/Definitions/Concepts/Condition/BodyCondition'
import CustomInput from '../../../components/General/CustomInput';
import _ from 'lodash';

const newInfo = {
    desTipoCondicInsegu: null,
    estado_id: 1,
    edit: 1,
}

const Condition = (props) => {
    const { states, data, setData, getInfo } = props;
    const dispatch = useDispatch();
    const handleOpenLoader = (value) => dispatch(setOpenLoader(value));
    const handleTitleLoader = (value) => dispatch(setTitleLoader(value));

    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    
    
    const addCondicion = () => {
        let updData = _.cloneDeep(data);
        updData?.push(newInfo);
        return setData(updData);
    }

    const handleSearch = (search) => {
        setSearch(search);
        const filtered = data.filter(item =>
            item.desTipoCondicInsegu.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredData(filtered);
    };

    return (
        <div>
            <h1 className='text-center title-page'>Definición de Condición Insegura</h1>
            <div className='row justify-content-center'>
                <div className='col-md-5'>
                    <CustomInput
                        placeholder={'Buscar condición insegura'}
                        value={search}
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                </div>
                <div className='col-md-2 d-flex justify-content-evenly align-items-end'>
                    <button className='btn btn-sm btn-primary' type='button' onClick={addCondicion}><AddCircleIcon fontSize='small' /> Crear</button>
                </div>
            </div>
            <div className='row justify-content-center mt-3'>
                <div className='col-md-7 col-sm-10'>
                    <BodyCondition
                        states={states}
                        data={filteredData.length > 0 ? filteredData : data}
                        setData={setData}
                        getInfo={getInfo}
                       
                    />
                </div>
            </div>
        </div>
    )
}

export default Condition